<template>
    <v-banner sticky ref="header" class="white ma-0 pa-0 fixed" elevation="0" max-width="100%">
        <v-card class="d-flex justify-space-between pa-0 ma-0" elevation="0">
            <v-container class="pa-0 ma-0">
                <v-img src="@/assets/logo/PLABSID LOGO NEW BLACK.png" width="150"></v-img>
            </v-container>
            <v-container class="pa-0 ma-0 font-weight-bold text-body-1 text-center">
                Display Kitchen
                <v-icon color="myGreen" class="pa-0 mb-1">mdi-chef-hat</v-icon>
            </v-container>
            <v-container class="pa-0 ma-0 text-right">
                <v-btn class="ma-0 primary" small @click="logout">Logout</v-btn>
            </v-container>
        </v-card>
    </v-banner>
</template>

<script>
import { mapActions } from "vuex";
export default {
    methods: {
        ...mapActions(["SET_LOGIN_MODAL"]),
        logout() {
            return this.SET_LOGIN_MODAL(true);
        },
    },
};
</script>
